import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_PaymentmethodListComponent from "../components/_FM_paymentmethod/_FM_PaymentmethodListComponent";
import _FM_PaymentmethodFormComponent from "../components/_FM_paymentmethod/_FM_PaymentmethodFormComponent";
import _FM_PaymentmethodShowComponent from "../components/_FM_paymentmethod/_FM_PaymentmethodShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_PaymentmethodPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('payment_methods') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/payment-method')
  }, []);

  return (
    <div className="_FM_PaymentmethodPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/payment-method"}/>
      <Panel>
        <_FM_PaymentmethodListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/payment-method');
               }}>
        <_FM_PaymentmethodFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/payment-method');
               }}>
        <_FM_PaymentmethodShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_PaymentmethodPage);
